export const FiltrosTransaccion = {
    sedes: [2, 3, 5, 7, 8, 10, 13, 17, 18],
    centroTrabajo: [3, 5, 7, 8, 10, 13, 17, 18],
    dniAfiliado: [5, 7, 8, 10, 17, 18],
    periodo: [12]
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_general/modelo/FiltrosPorTransaccion.ts